import commonConstant from '../../common/_commonConstant';

export const problemColor = getProblems => {
  try {
    const code = getProblems.problemCode ? getProblems.problemCode : getProblems.problem.problemCode ? getProblems.problem.problemCode : null;

    if (code) {
      switch (code) {
        case commonConstant.vehicleLicensePlateProblem:
          return 'problem-code-car-plate';
        case commonConstant.barrierProblem:
          return 'problem-code-barrier';
        case commonConstant.paymentProblem:
          return 'problem-code-payment';
        case commonConstant.overdueProblem:
          return 'problem-code-overdue';
        case commonConstant.physicalDamageProblem:
          return 'problem-code-physical-damage';
        case commonConstant.otherProblem:
          return 'problem-code-other';
        default:
          return '';
      }
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const problemName = getProblems => {
  try {
    return getProblems.problemName ? getProblems.problemName : getProblems.problem.problemName ? getProblems.problem.problemName : null;
  } catch (error) {
    return null;
  }
};
